import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createEmergencyContact,
  deleteEmergencyContactById,
  updateEmergencyContact,
} from '../thunks/emergencyContacts';

const emergencyContactsAdapter = createEntityAdapter({});

export const emergencyContactsSlice = createSlice({
  name: 'emergencyContacts',
  initialState: emergencyContactsAdapter.getInitialState({}),
  reducers: {
    setEmergencyContacts: (state, action) => {
      emergencyContactsAdapter.upsertMany(state, action.payload);
    },
    addNewEmergencyContact: (state, action) => {
      emergencyContactsAdapter.addOne(state, action.payload);
    },
    removeEmergencyContact: (state, action) => {
      emergencyContactsAdapter.removeOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEmergencyContact.fulfilled, (state, action) => {
        emergencyContactsAdapter.upsertOne(state, action.payload);
      })
      .addCase(deleteEmergencyContactById.fulfilled, (state, action) => {
        const { id } = action.payload;
        emergencyContactsAdapter.removeOne(state, id);
      })
      .addCase(updateEmergencyContact.fulfilled, (state, action) => {
        const { id } = action.payload;
        emergencyContactsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      });
  },
});

export const {
  setEmergencyContacts,
  addNewEmergencyContact,
  removeEmergencyContact,
} = emergencyContactsSlice.actions;

export const emergencyContactsAdapterSelectors =
  emergencyContactsAdapter.getSelectors((state) => state.emergencyContacts);

export default emergencyContactsSlice.reducer;
